export default __webpack_public_path__ + "static/media/MulticolorIris.fd384aa6.jpg";